import React from 'react';
import { motion } from 'framer-motion';
import { LeafIcon } from 'lucide-react';
const MONTHS = [{
  month: 'Ene',
  value: 62
}, {
  month: 'Feb',
  value: 58
}, {
  month: 'Mar',
  value: 64
}, {
  month: 'Abr',
  value: 55
}, {
  month: 'May',
  value: 51
}, {
  month: 'Jun',
  value: 49
}, {
  month: 'Jul',
  value: 52
}, {
  month: 'Ago',
  value: 46
}, {
  month: 'Sep',
  value: 44
}, {
  month: 'Oct',
  value: 41
}, {
  month: 'Nov',
  value: 39
}, {
  month: 'Dic',
  value: 37
}];
export function Co2Report() {
  const max = Math.max(...MONTHS.map(m => m.value));
  return <div className="border border-mist-200 bg-white p-5 shadow-lg md:p-7" data-id="element-70" data-mp="23bkwekplz9ht">
      <div className="flex flex-wrap items-start justify-between gap-4" data-id="element-71" data-mp="2h63qm8vef6p1">
        <div data-id="element-72" data-mp="2cdajxfgddoab">
          <h3 className="flex items-center gap-2 font-display text-lg font-bold tracking-tight text-graphite-900" data-id="element-73" data-mp="2ccj1z7fp3p2i">
            <LeafIcon className="h-4 w-4 text-brand-600" aria-hidden="true" data-id="element-74" data-mp="1omewsvmuzh9e" />
            Reporte mensual de CO₂
          </h3>
          <p className="mt-1 text-sm text-graphite-500" data-id="element-75" data-mp="r3x677l0qz82">Evolución de emisiones por operación, en tCO₂e</p>
        </div>
        <span className="border border-accent-300 bg-accent-300/20 px-2 py-0.5 text-[10px] font-bold uppercase tracking-[0.14em] text-accent-600" data-id="element-76" data-mp="w1yp9sig2yjj">
          Demo
        </span>
      </div>

      <div className="mt-8 flex h-48 items-end gap-2" role="img" aria-label="Gráfico de barras de evolución mensual de emisiones de CO₂ con datos de demostración" data-id="element-77" data-mp="15t332owdwdcs">
        {MONTHS.map((m, i) => <div key={m.month} className="flex h-full flex-1 flex-col items-center justify-end gap-2" data-id="element-78" data-mp="d3cmm97a4zdi" data-mpi={i}>
            <motion.div className="w-full bg-brand-600" initial={{
          height: 0
        }} whileInView={{
          height: `${m.value / max * 100}%`
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.26,
          delay: i * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-79" data-mp="i2fs1ur697m0" />
            <span className="text-[10px] text-graphite-500" data-id="element-80" data-mp="1yg60tet8kk1z">{m.month}</span>
          </div>)}
      </div>

      <dl className="mt-8 grid gap-6 border-t border-mist-200 pt-6 sm:grid-cols-3" data-id="element-81" data-mp="3uj2ez1gb9t0a">
        {[{
        label: 'Alcance medido',
        value: 'Operación de transporte y servicios'
      }, {
        label: 'Frecuencia',
        value: 'Reporte mensual'
      }, {
        label: 'Uso',
        value: 'Base para plan de reducción'
      }].map(item => <div key={item.label} data-id="element-82" data-mp="3c7zhykv0lzo">
            <dt className="text-[10px] uppercase tracking-[0.12em] text-graphite-500" data-id="element-83" data-mp="3bt2r2hw7ijyg">{item.label}</dt>
            <dd className="mt-1 text-sm font-medium text-graphite-900" data-id="element-84" data-mp="36vkgyo6gdyov">{item.value}</dd>
          </div>)}
      </dl>

      <p className="mt-6 text-[11px] leading-relaxed text-graphite-500" data-id="element-85" data-mp="3kmz8jjeff87j">
        Visualización de referencia con datos de demostración. Los valores publicados para cada cliente provienen
        exclusivamente de la medición de su propia operación.
      </p>
    </div>;
}